/**
 * Parse a UrlBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed UrlBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function url(view) {
    return {
        ...view.readFullBox(),
        location: view.readString(-1),
    };
}
;
//# sourceMappingURL=url.js.map